module.exports = __webpack_public_path__ + "img/avatar.a60a912.png";